import { IBaseProps } from '@did/types'
import React from 'react'
import { NotFound } from '@did/das-balance-components'
import { useDasBalanceContext } from '@did/das-app-context'
import { useDidPointBalance } from '@did/das-balance-hooks'
import DidPointBalance from './DidPointBalance'
import { RecordList } from './record-list'
import { AboutFaq } from '@did/uikit'

export const CreditsIndex: React.FC<IBaseProps> = () => {
  const { tt } = useDasBalanceContext()
  const { balance } = useDidPointBalance()

  return (
    <div className="px-3 mx-auto sm:px-0 w-full md:w-[33rem] mb-6">
      <h3 className="text-base mx-4 mb-6 mt-8 text-center font-bold">
        {tt('Manage your Credits with ease (formerly DIDPoint)')}
      </h3>
      <AboutFaq
        className="mb-3"
        title={tt('About DIDPoint')}
        message={tt(
          'DIDPoint is a tool used for various operations within .bit and related third-party tools. For instance, you can use DIDPoints for account registration and renewal. 1 DIDPoint is always equivalent to 1 USD.'
        )}
        faqMessage={tt('FAQ')}
        localStorageKey="did-point_about-did-point_hide"
        faqUrl="https://community.d.id/c/knowledge-base-bit/didpoint-faq"
      />
      <DidPointBalance balance={balance} />
      <RecordList
        balance={balance}
        className="px-0 sm:px-2"
        NotFound={NotFound}
      />
    </div>
  )
}
